/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section3_P1Inputs */

const en_privacy_section3_p1 = /** @type {(inputs: Privacy_Section3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON uses your browser's localStorage to save your theme preference (light/dark mode) and language preference. This data is stored only on your device and is never transmitted to any server.`)
};

const ko_privacy_section3_p1 = /** @type {(inputs: Privacy_Section3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON은 브라우저의 localStorage를 사용하여 테마 설정(라이트/다크 모드)과 언어 설정을 저장합니다. 이 데이터는 사용자의 기기에만 저장되며 서버로 전송되지 않습니다.`)
};

const ja_privacy_section3_p1 = /** @type {(inputs: Privacy_Section3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONはブラウザのlocalStorageを使用して、テーマ設定（ライト/ダークモード）と言語設定を保存します。このデータはデバイスにのみ保存され、サーバーに送信されることはありません。`)
};

/**
* | output |
* | --- |
* | "PureJSON uses your browser's localStorage to save your theme preference (light/dark mode) and language preference. This data is stored only on your device an..." |
*
* @param {Privacy_Section3_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_section3_p1 = /** @type {((inputs?: Privacy_Section3_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section3_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_section3_p1(inputs)
	if (locale === "ko") return ko_privacy_section3_p1(inputs)
	return ja_privacy_section3_p1(inputs)
});